import { mooberApiV2 as apiV2 } from '@/api/mooberApi';

const assignTrucks = ({ loadId, body }) => apiV2.post(`load/${loadId}/assignTrucks`, body);
const assignQbVendor = ({ loadId, body }) => apiV2.post(`load/${loadId}/assignQbVendor`, body);
const assignVendor = ({ loadId, body }) => apiV2.post(`load/${loadId}/assignVendor`, body);
const postToLoadBoard = ({ loadId, body }) => apiV2.post(`load/${loadId}/loadBoard`, body);
const removeFromLoadBoard = ({ loadId }) => apiV2.delete(`load/${loadId}/loadBoard`);
const dispatch = ({ loadId, body }) => apiV2.post(`load/${loadId}/dispatch`, body);
const cancelDispatch = ({ loadId, dispatchId }) => apiV2.delete(`load/${loadId}/dispatch/${dispatchId}`);
const unscheduleBookedLoad = ({ loadId, bookedLoadId }) => apiV2.delete(`load/${loadId}/booked/${bookedLoadId}`);
const updateLoad = load => apiV2.put(`load/${load.humanId}`, load);
const getLoad = loadId => apiV2.get(`load/${loadId}`);
const repeatLoad = (loadId, body) => apiV2.post(`load/${loadId}/repeat`, body);

export default {
  repeatLoad,
  assignTrucks,
  assignVendor,
  assignQbVendor,
  cancelDispatch,
  dispatch,
  postToLoadBoard,
  removeFromLoadBoard,
  unscheduleBookedLoad,
  updateLoad,
  getLoad,
};



// WEBPACK FOOTER //
// ./src/api/planner.js